export enum LookupCategories {
  EvaluationTypes = 1,
  EvaluationCategory = 2,
  EvaluationSubCategory = 3,
  EvaluationAction = 4
}
